import { Drawer, IconButton, Box, TextField, Button, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import React, { useState } from 'react';

const IssueDetailsModal = ({ issue, isOpen, onClose, closeIssue, openInWrike }) => {
  const [comment, setComment] = useState('');

  if (!issue) return null;

  const handleCommentChange = (event) => {
    setComment(event.target.value);
  };

  return (
    <Drawer anchor="right" open={isOpen} onClose={onClose}>
      <Box sx={{
        width: '50vw',
        padding: 3,
        display: 'flex',
        flexDirection: 'column',
        height: '100%'
      }}>
        <IconButton onClick={onClose} sx={{ marginLeft: 'auto', marginBottom: 2 }}>
          <CloseIcon />
        </IconButton>
        <Typography variant="h5" component="h2" sx={{ textTransform: 'uppercase', marginBottom: 2, fontWeight: 'bold' }}>
          {issue.title}
        </Typography>
        <Typography variant="body1" sx={{ marginBottom: 1 }}>
          <Box component="span" sx={{ fontWeight: 'bold' }}>Opened by:</Box> {issue.openedByUser}
        </Typography>
        <Typography variant="body1" sx={{ marginBottom: 1 }}>
          <Box component="span" sx={{ fontWeight: 'bold' }}>Severity:</Box> {issue.severity}
        </Typography>
        <Typography variant="body1" sx={{ marginBottom: 1 }}>
          <Box component="span" sx={{ fontWeight: 'bold' }}>Location:</Box> {issue.location}
        </Typography>
        <Typography variant="body1" sx={{ marginBottom: 1 }}>
          <Box component="span" sx={{ fontWeight: 'bold' }}>Asset Name:</Box> {issue.assetName}
        </Typography>
        <Typography variant="body1" sx={{ marginBottom: 1 }}>
          <Box component="span" sx={{ fontWeight: 'bold' }}>Asset Type:</Box> {issue.assetType}
        </Typography>
        <Typography variant="body1" sx={{ marginBottom: 1 }}>
          <Box component="span" sx={{ fontWeight: 'bold' }}>Description:</Box> {issue.detail}
        </Typography>
        <Typography variant="body1" sx={{ marginBottom: 1 }}>
          <Box component="span" sx={{ fontWeight: 'bold' }}>Resolve Attempt:</Box> {issue.note}
        </Typography>
        <Typography variant="body1" sx={{ marginBottom: 1 }}>
          <Box component="span" sx={{ fontWeight: 'bold' }}>Category:</Box> {issue.issueCategory}
        </Typography>
        <Typography variant="body1" sx={{ marginBottom: 1 }}>
          <Box component="span" sx={{ fontWeight: 'bold' }}>Sub Category:</Box> {issue.issueSubCategory}
        </Typography>
        <Typography variant="body1" sx={{ marginBottom: 1 }}>
          <Box component="span" sx={{ fontWeight: 'bold' }}>Closed By:</Box> {issue.closedByUser}
        </Typography>
        <Typography variant="body1" sx={{ marginBottom: 1 }}>
          <Box component="span" sx={{ fontWeight: 'bold' }}>Closed On:</Box> {issue.closedOn ? new Date(issue.closedOn).toLocaleString(['en-IE', 'en-GB']) : ''}
        </Typography>
        <Typography variant="body1" sx={{ marginBottom: 1 }}>
          <Box component="span" sx={{ fontWeight: 'bold' }}>Closing comment:</Box> {issue.closingNote}
        </Typography>
        <Typography variant="body1" sx={{ marginBottom: 1 }}>
          <Box component="span" sx={{ fontWeight: 'bold' }}>Slack Link:</Box> <a href={issue.slackMessageWeblink} target="_blank" rel="noopener noreferrer">{issue.slackMessageWeblink}</a>
        </Typography>
        <Box sx={{ mt: 2, display: 'flex', alignItems: 'center' }}>
          <TextField
            id="comment-field"
            label="Comment"
            variant="outlined"
            value={comment}
            onChange={handleCommentChange}
            sx={{ mr: 2, flexGrow: 1 }}
          />
          <Button variant="contained" color="primary" onClick={() => closeIssue(comment, issue.id)}>
            Close Issue
          </Button>
        </Box>
        <Box sx={{ mt: 2, display: 'flex', alignItems: 'center' }}>
          <Button variant="contained" color="primary" onClick={() => openInWrike(issue)}>
            Open In Wrike
          </Button>
        </Box>
      </Box>
    </Drawer>
  );
};

export default IssueDetailsModal;
